<template>
  <div class="admin--nav">
      <div class="admin--nav__logo">
        <img src="../../assets/railroad-08a-300x101.png" alt="">
      </div>
    <div class="admin--nav__menu">
      <el-menu :router="true" mode="horizontal" @select="handleSelect">
        <el-submenu index="1">
          <template slot="title">
            <span><i class="fas fa-cog"></i></span>
            <span>Dashboard</span>
          </template>
          <el-menu-item :route="{name: 'Dashboard'}" index="1-1">
            <span><i class="fas fa-chart-line"></i></span>
            <span>Recent</span>
          </el-menu-item>
          <el-menu-item :route="{name: 'Trips'}" index="1-2">
            <span><i class="fas fa-street-view"></i></span>
            <span>Trips</span>
          </el-menu-item>
          <el-menu-item :route="{name: 'Passengers'}" index="1-3">
            <span><i class="fas fa-street-view"></i></span>
            <span>Passengers</span>
          </el-menu-item>
          <el-menu-item :route="{name: 'InjectPassenger'}" index="1-3">
            <span><i class="fas fa-street-view"></i></span>
            <span>Inject Passengers</span>
          </el-menu-item>
          <el-menu-item :route="{name: 'CreateOfflinePassenger'}" index="1-3">
            <span><i class="fas fa-street-view"></i></span>
            <span>Offline Passengers</span>
          </el-menu-item>
          <el-menu-item :route="{name: 'Transactions'}" index="1-4">
            <span><i class="fas fa-hand-holding-usd"></i></span>
            <span>Transactions</span>
          </el-menu-item>
          <el-menu-item :route="{name: 'ReportManager'}" index="1-5">
            <span><i class="fas fa-hand-holding-usd"></i></span>
            <span>Report Generator</span>
          </el-menu-item>
        </el-submenu>

        <el-submenu index="2">
          <template slot="title">
              <span><i class="fas fa-cog"></i></span>
            <span>Configuration</span>
          </template>
          <el-menu-item :route="{name: 'Location'}" index="3-1">
            <span><i class="fas fa-map-marked-alt"></i></span>
            <span>Location</span>
          </el-menu-item>
          <el-menu-item :route="{name: 'Fares'}" index="3-2">
            <span><i class="fas fa-hand-holding-usd"></i></span>
            <span>Route</span>
          </el-menu-item>
          <el-menu-item :route="{name: 'Drivers'}" index="3-3">
            <span><i class="fas fa-user"></i></span>
            <span>Drivers</span>
          </el-menu-item>
          <el-menu-item :route="{name: 'Vehicles'}" index="3-4">
            <span><i class="fas fa-car"></i></span>
            <span>Vehicles</span>
          </el-menu-item>
        </el-submenu>

        <el-menu-item :route="{name: 'Profile'}" index="3">
          <span><i class="fas fa-street-view"></i></span>
          <span>Profile</span>
        </el-menu-item>
        <el-menu-item :route="{name: 'UserAdmin'}" index="4">
          <span><i class="fas fa-lock"></i></span>
          <span>Admin</span>
        </el-menu-item>
      </el-menu>

    </div>

    <div class="admin--mobile--menu">
      <el-button type="primary" @click="gotoMobileMenu()" style="width: 100%">
        <i class="fas fa-bars"></i>
        SHOW MENU
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminNav',
  data () {
    return {
      activeIndex: '3-5'
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      // TODO some path manuipulation here
    },

    gotoMobileMenu () {
      this.$router.push({
        name: 'MobileMenu'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .admin--nav {
    display: flex;
    align-items: center;

    .admin--nav__menu {
      margin-left: auto
    }
  }
  .admin--mobile--menu {
    display: none;
  }

  @media screen and (max-width: 600px){
    .admin--nav__menu {
      display: none;
    }
    .admin--mobile--menu {
      margin: 10px;
      display: block;
      width: 100%;
    }
    .admin--nav {
      .admin--nav__logo {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminNav.vue